import { useQuery } from '@tanstack/react-query';

import { CustomNotification } from 'common/components';
import { getProductOrientationAssets } from 'services/product';

export const getKeyProductOrientationAssets = (productId) => {
  return ['get-orientation-assets', productId];
};

export const useGetProductOrientationAssets = ({ productId }) =>
  useQuery({
    queryKey: getKeyProductOrientationAssets(productId),
    queryFn: async () => {
      const response = await getProductOrientationAssets({
        productId: productId,
      });

      if (response?.isSuccess) {
        return response?.data;
      } else {
        CustomNotification.error(
          response?.message || 'Product orientation assets not found'
        );
        return;
      }
    },
    onSuccess: () => {},
    onError: () => {
      CustomNotification.error('Something went wrong!');
    },
  });
